import axios from "axios";
import config from "../config/app.config";
import { setAuthorizationToken } from "../helpers/axios";

setAuthorizationToken();

const Api = {
  getAllMember: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/getallMember`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getTransaction: async () => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/getTransaction`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getWithdrawalTransaction: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getWithdrawalTransaction`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getDepositTransaction: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getDepositTransaction`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getdataMerchang: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getdataMerchang`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  postEditProfile: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/postEditProfile`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getListOfBankAccounts: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getListOfBankAccounts`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getallAdmin: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getallAdmin`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getall_BankGrop: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getall_BankGrop`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },

  // Report
  postOverviewReports: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/postOverviewReport`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },

  postOverviewReportChart: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/postOverviewReportChart`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getRole_permissions: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/role_permissions`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data
    };

    return await axios(resData);
  },
  getRole_menu: async () => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/role_menu`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getInvoice: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/chack_Invoice`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getReportCustomersSummary: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/report_customers_summary`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  /**
   * ส่งข้อมูลแจ้ง error กลุ่ม support ผ่าน Telegram
   * @param {string} message - ข้อความที่จัดรูปแบบ HTML แล้ว
   */
  getApiTelegram: async (message) => {
    const resData = {
      method: "POST",
      url: `https://api.telegram.org/bot${config.TOKEN}/sendMessage`,
      data: {
        chat_id: config.CHAT_ID,
        text: message,
        parse_mode: "HTML",
        disable_web_page_preview: true, // ป้องกันการสร้าง preview ลิงก์ที่รกหน้าจอ
      },
    };

    return await axios(resData);
  },

  /**
 * ส่งข้อมูลแจ้ง error กลุ่ม support ผ่าน Telegram
 * @param {string} message - ข้อความที่จัดรูปแบบ HTML แล้ว
 */
  getApiTelegramSupport: async (message) => {
    const resData = {
      method: "POST",
      url: `https://api.telegram.org/bot${config.TOKEN_TELE_SUPPORT}/sendMessage`,
      data: {
        chat_id: config.CHAT_ID_TELE_SUPPORT,
        text: message,
        parse_mode: "HTML",
        disable_web_page_preview: true, // ป้องกันการสร้าง preview ลิงก์ที่รกหน้าจอ
      },
    };

    return await axios(resData);
  },

  /**
    * ส่งข้อมูลแจ้งเตือนไปยังกลุ่ม Telegram (รองรับข้อความปกติ และ ข้อความพร้อมรูปภาพ)
    * @param {FormData} data - ประกอบด้วย chat_id, message และ image (ถ้ามี)
    */
  getApiNofAllTelegram: async (data) => {
    const chatId = data.get("chat_id");
    const message = data.get("message");
    const imageFile = data.get("image");

    const activeBotToken = config.TOKEN_ANNOUNCE;

    let resData = {};

    if (imageFile) {
      // ------ กรณีมีรูปภาพ: ใช้ Endpoint "sendPhoto" ------
      const teleFormData = new FormData();
      teleFormData.append("chat_id", chatId);
      teleFormData.append("photo", imageFile);

      // ✨ แก้ไขจุดสำคัญ: เช็คก่อนว่ามีข้อความพิมพ์มาไหม ถ้ามีและไม่ใช่แค่ช่องว่าง ค่อยแนบ caption ไป
      if (message && message.trim() !== "") {
        teleFormData.append("caption", message);
        teleFormData.append("parse_mode", "HTML");
      }

      resData = {
        method: "POST",
        url: `https://api.telegram.org/bot${activeBotToken}/sendPhoto`,
        data: teleFormData,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
    } else {
      // ------ กรณีไม่มีรูปภาพ: ใช้ Endpoint "sendMessage" ------

      // ✨ แก้ไขจุดสำคัญ: หากไม่มีรูปภาพ และข้อความก็ดันว่างเปล่าด้วย ให้ใส่ข้อความเริ่มต้นระบบกันพัง
      let textToSend = message;
      if (!textToSend || textToSend.trim() === "") {
        textToSend = "🔔 <i>(ไม่มีข้อความแจ้งเตือน พิมพ์ส่งเฉพาะหัวข้อเรื่อง)</i>";
      }

      resData = {
        method: "POST",
        url: `https://api.telegram.org/bot${activeBotToken}/sendMessage`,
        data: {
          chat_id: chatId,
          text: textToSend, // ปลอดภัยแน่นอน เพราะผ่านการดักจับค่าว่างแล้ว
          parse_mode: "HTML",
          disable_web_page_preview: true,
        },
      };
    }

    return await axios(resData);
  },
};

export default Api;
